var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr } from '@ember-data/model';
import { CatalogServiceChargeType, CatalogServiceChargeCalculationPhase, CatalogServiceChargeCalculationType, CatalogServiceChargeTreatmentType } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/enums';
import { fragment } from 'ember-data-model-fragments/attributes';
import CatalogFragment from '../catalog-fragment';
export let CATALOG_SERVICE_CHARGE_TYPE = /*#__PURE__*/function (CATALOG_SERVICE_CHARGE_TYPE) {
  CATALOG_SERVICE_CHARGE_TYPE["AUTO_GRATUITY"] = "AUTO_GRATUITY";
  CATALOG_SERVICE_CHARGE_TYPE["CUSTOM"] = "CUSTOM";
  CATALOG_SERVICE_CHARGE_TYPE["CARD_SURCHARGE"] = "CARD_SURCHARGE";
  return CATALOG_SERVICE_CHARGE_TYPE;
}({});
export let CATALOG_SERVICE_CHARGE_CALCULATION_PHASE = /*#__PURE__*/function (CATALOG_SERVICE_CHARGE_CALCULATION_PHASE) {
  CATALOG_SERVICE_CHARGE_CALCULATION_PHASE["SURCHARGE_PHASE"] = "SURCHARGE_PHASE";
  CATALOG_SERVICE_CHARGE_CALCULATION_PHASE["SURCHARGE_TOTAL_PHASE"] = "SURCHARGE_TOTAL_PHASE";
  CATALOG_SERVICE_CHARGE_CALCULATION_PHASE["SURCHARGE_APPORTIONED_PHASE"] = "SURCHARGE_APPORTIONED_PHASE";
  CATALOG_SERVICE_CHARGE_CALCULATION_PHASE["CARD_SURCHARGE_PHASE"] = "CARD_SURCHARGE_PHASE";
  return CATALOG_SERVICE_CHARGE_CALCULATION_PHASE;
}({});
export let CATALOG_SERVICE_CHARGE_CALCULATION_TYPE = /*#__PURE__*/function (CATALOG_SERVICE_CHARGE_CALCULATION_TYPE) {
  CATALOG_SERVICE_CHARGE_CALCULATION_TYPE["SURCHARGE_FIXED"] = "SURCHARGE_FIXED";
  CATALOG_SERVICE_CHARGE_CALCULATION_TYPE["SURCHARGE_VARIABLE_PERCENTAGE"] = "SURCHARGE_VARIABLE_PERCENTAGE";
  CATALOG_SERVICE_CHARGE_CALCULATION_TYPE["SURCHARGE_VARIABLE_AMOUNT"] = "SURCHARGE_VARIABLE_AMOUNT";
  return CATALOG_SERVICE_CHARGE_CALCULATION_TYPE;
}({});
export let CATALOG_SERVICE_CHARGE_TREATMENT_TYPE = /*#__PURE__*/function (CATALOG_SERVICE_CHARGE_TREATMENT_TYPE) {
  CATALOG_SERVICE_CHARGE_TREATMENT_TYPE["SURCHARGE_TREATMENT_LINE_ITEM"] = "SURCHARGE_TREATMENT_LINE_ITEM";
  CATALOG_SERVICE_CHARGE_TREATMENT_TYPE["SURCHARGE_TREATMENT_APPORTIONED"] = "SURCHARGE_TREATMENT_APPORTIONED";
  return CATALOG_SERVICE_CHARGE_TREATMENT_TYPE;
}({});
let Data = (_dec = fragment('price-money'), _dec2 = attr('string', {
  enumClass: CATALOG_SERVICE_CHARGE_CALCULATION_PHASE,
  protoEnum: CatalogServiceChargeCalculationPhase,
  defaultValue: CATALOG_SERVICE_CHARGE_CALCULATION_PHASE.SURCHARGE_PHASE
}), _dec3 = attr('string', {
  enumClass: CATALOG_SERVICE_CHARGE_CALCULATION_TYPE,
  protoEnum: CatalogServiceChargeCalculationType,
  defaultValue: CATALOG_SERVICE_CHARGE_CALCULATION_TYPE.SURCHARGE_FIXED
}), _dec4 = attr('string'), _dec5 = attr('string'), _dec6 = attr('boolean'), _dec7 = attr('string', {
  enumClass: CATALOG_SERVICE_CHARGE_TREATMENT_TYPE,
  protoEnum: CatalogServiceChargeTreatmentType,
  defaultValue: CATALOG_SERVICE_CHARGE_TREATMENT_TYPE.SURCHARGE_TREATMENT_LINE_ITEM
}), _dec8 = attr('string', {
  enumClass: CATALOG_SERVICE_CHARGE_TYPE,
  protoEnum: CatalogServiceChargeType
}), _class = class Data extends CatalogFragment {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "amountMoney", _descriptor, this);
    _initializerDefineProperty(this, "calculationPhase", _descriptor2, this);
    _initializerDefineProperty(this, "calculationType", _descriptor3, this);
    _initializerDefineProperty(this, "name", _descriptor4, this);
    _initializerDefineProperty(this, "percentage", _descriptor5, this);
    _initializerDefineProperty(this, "taxable", _descriptor6, this);
    _initializerDefineProperty(this, "treatmentType", _descriptor7, this);
    _initializerDefineProperty(this, "type", _descriptor8, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "amountMoney", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "calculationPhase", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "calculationType", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "name", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "percentage", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "taxable", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "treatmentType", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "type", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { Data as default };